import React from "react";
import { Link } from "react-router-dom";
import { SkeletonBone } from "../../../Component/Skeleton";

export default function VoucherModifySelector({
  existingVouchers = [],
  selectedVoucherId = "",
  onSelectVoucher,
  onOpenSearchModal,
  onClearSelection,
  isLoadingVoucher = false,
  isLoadingList = false,
  loadedVoucher = null,
}) {
  return (
    <div className="vch_modify_selector_bar">
      <div className="vch_modify_selector_left">
        <div className="vch_modify_icon_badge">
          <i className="fa-solid fa-pen-to-square"></i>
        </div>
        <div className="vch_modify_label_wrap">
          <span className="vch_modify_title">Modify Voucher:</span>
          <span className="vch_modify_subtitle">
            Search and select an existing voucher to load and update its details
          </span>
        </div>

        {/* Open Search & Filter Modal Button */}
        <button
          type="button"
          className="vch_btn_search_voucher"
          onClick={onOpenSearchModal}
          title="Open advanced voucher search with date & type filters"
        >
          <i className="fa-solid fa-magnifying-glass"></i>
          <span>Search Voucher</span>
        </button>

        {isLoadingVoucher && (
          <div style={{ display: "flex", alignItems: "center", gap: "8px", marginLeft: "8px" }}>
            <SkeletonBone width="120px" height="20px" borderRadius="4px" />
            <SkeletonBone width="70px" height="20px" borderRadius="4px" />
          </div>
        )}
      </div>

      <div className="vch_modify_selector_right">
        <Link
          to="/transactions/voucher-entry"
          className="vch_btn_new_entry_switch"
          title="Switch to New Voucher Entry mode"
          onClick={() => {
            if (onClearSelection) onClearSelection();
          }}
        >
          <i className="fa-solid fa-plus"></i>
          <span>New Voucher Entry</span>
        </Link>
      </div>
    </div>
  );
}
